<template>
  <div style="padding: 12px; max-width: 500px; margin: 0 auto;">

    <!-- 用戶信息頭 -->
    <div style="display: flex; align-items: center; gap: 16px; margin: 12px 0 24px 0;" v-if="userDataInfo.id">
      <div style="width: 64px; height: 64px; border-radius: 50%;">
        <!-- <img :src="`/api/file/download/${userDataInfo.img}`" alt="" srcset="" style="width: 100%; height: 100%; border-radius: 50%;"> -->
        <img :src="`/api/file/download/${userDataInfo.img}`" alt="" srcset=""
          style="width: 100%; height: 100%; border-radius: 50%;">
      </div>
      <div style="flex:1">
        <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 6px;">
          <div style="font-size: 20px; color: #3E4F7A; font-weight: 600;">{{ userDataInfo.nick }}</div>
          <div style="padding: 2px 8px; background: #E8F5ED; border-radius: 4px;
                    color: #43974E; font-size: 12px;">{{ nowVip.name }}</div>
        </div>
        <!-- 餘額與刷新按鈕 -->
        <div style="display: flex; justify-content: space-between; align-items: center; gap: 12px;">
          <div style="display: flex; align-items: center;">
            <div style="font-size: 22px; color: #A3281C; font-weight: 600;">
              <span style="font-size: 12px;">HKD</span> {{ Number(userDataInfo.balance / 100).toFixed(2) }}
            </div>
            <button @click="refreshUser" style="padding: 8px; margin-left: 10px; background: #F6F8FB; border: 1px solid #E0E0E0;
                  border-radius: 8px; cursor: pointer; 
                  transition: all 0.3s ease;">
              <span style="display: block; transform: rotate(0deg); 
                      transition: transform 0.5s;">
                🔄
              </span>
            </button>
          </div>

        </div>


      </div>
    </div>


    <div v-if="userDataInfo.accumulate" style="margin-bottom: 20px; padding: 16px; background: #f8f9ff;
              border-radius: 8px; border: 1px solid #e0e4ff;">
      <div style="color: #666; font-size: 14px; margin-bottom: 8px; display: flex; justify-content: space-between;">
        <div>累計充值</div>
        <div>
          <div style="display: flex; align-items: center; font-size: 12px; color: #3E4F7A; " @click="goTopUp">
            <span style="font-weight: 800; font-size: 14px;">💰 去充值</span>
            <div style="padding-top: 2px;">
              <img src="../assets/youbian.png" style="width: 10px; height: 10px; margin-left: 2px;">
            </div>
          </div>
        </div>
      </div>
      <div style="margin-top: 10px;">
        <div v-if="nextVip.amount">
          <el-progress :percentage="Number(userDataInfo.accumulate / nextVip.amount * 100)" :show-text="false"
            :stroke-width="14"></el-progress>
          <div style="text-align: center; font-size: 14px; margin-top: 6px; color: #3E4F7A; font-weight: bold;">
            <span>{{ Number(userDataInfo.accumulate / 100).toFixed(2) }}</span> / <span>{{ Number(nextVip.amount /
              100).toFixed(2)
            }}</span> HKD <span> - 下一個等級 {{ nextVip.name }}</span>
          </div>
        </div>
        <div v-else>
          <el-progress :percentage="100" :show-text="false" :stroke-width="14"></el-progress>
          <div style="text-align: center; font-size: 14px; margin-top: 6px; color: #3E4F7A; font-weight: bold;">
            <span>您已累計充值 {{ Number(userDataInfo.accumulate / 100).toFixed(2) }} HKD - 享受最高等級特權</span>
          </div>
        </div>
      </div>
    </div>

    <!-- {{ nowVip }} -->

    <!-- {{ nextVip }} -->

    <!-- USDT充值地址 -->
    <!-- <div style="margin-bottom: 20px; padding: 16px; background: #f8f9ff;
              border-radius: 8px; border: 1px solid #e0e4ff;">
      <div style="color: #666; font-size: 14px; margin-bottom: 8px;">
        USDT-TRC20 充值地址
      </div>
      <div style="display: flex; align-items: center; gap: 8px;">
        <div style="flex:1; word-break: break-all; font-family: monospace;
                padding: 10px; background: #fff; border-radius: 6px;
                border: 1px solid #eee;">
          {{ userDataInfo.trc_address || "暫不支持USDT充值" }} 
        </div>
        <button @click="copyAddress" style="padding: 10px; background: #f0f2ff; border-radius: 6px;
                border: 1px solid #d0d4ff; cursor: pointer;">
          📋
        </button>
      </div>
      複製成功提示
      <transition name="fade">
        <div v-if="showCopySuccess" style="position: fixed; top: 20px; left: 50%; transform: translateX(-50%);
              padding: 8px 16px; background: #4CAF50; color: white; border-radius: 4px;
              box-shadow: 0 2px 4px rgba(0,0,0,0.2);">
          ✅ 已複製地址
        </div>
      </transition>
      新增提示信息
      <div style="margin-top: 12px; padding: 10px; background: #e8f4ff;
                border-radius: 6px; display: flex; gap: 8px;
                color: #2a5a9e; font-size: 13px;">
        <div>✅</div>
        <div>提示：充值USDT到該地址後，系統會自動確認到賬（通常需要2-10分鐘）</div>
      </div>
    </div> -->

    <!-- 功能入口 -->
    <!-- <div style="display: grid; gap: 12px; margin-bottom: 24px;">
      <button style="padding: 14px; background: #F6F8FB; border: 1px solid #43974E;
                border-radius: 8px; color: #43974E; cursor: pointer; font-size: 15px;" @click="log()">
        📖 查看充值記錄
      </button>
    </div> -->

    <!-- 已購項目 -->
    <div>
      <div style="font-size: 20px; color: #3E4F7A; font-weight: 600; margin-bottom: 16px;">
        我購買的項目
      </div>
      <div style="display: grid; gap: 12px;">
        <div v-if="projects.length > 0">
          <div v-for="(item, index) in projects" :key="index"
            style="background: #F6F8FB; border-radius: 8px; padding: 12px; margin-bottom: 12px;">
            <div style="display: flex; align-items: center;">
              <div>
                <img :src="`/api/file/download/${item.order.icon}`" alt="" style="width: 38px;">
              </div>
              <div style="margin-left: 16px; flex: 1;">
                <div style="display: flex; justify-content: space-between; align-items: center;">
                  <div style="font-weight: 600; color: #3E4F7A; font-size: 15px;">{{ item.order.title }}</div>
                  <div><el-tag size="small">{{ item.order.status === 0 ? '待發貨' : item.order.status === 1 ? '已完成' :
                    item.order.status === 2
                      ? '已評價' : '未知' }}</el-tag></div>
                </div>
                <div style="color: #666; font-size: 13px; line-height: 1.6;">
                  <div>價格：{{ Number(item.order.price / 100).toFixed(2) }} HKD</div>
                  <div>購買時間：{{ formatTimestamp(item.order.create_at) }}</div>
                </div>
              </div>
            </div>
            <div style="display: flex; justify-content: flex-end; margin-top: 12px;">
              <div>
                <el-button type="primary" size="mini" @click="meeting()">客服</el-button>
              </div>
              <div style="margin-left: 12px;" @click="meeting()">
                <el-button type="primary" size="mini">取貨</el-button>
              </div>
              <div style="margin-left: 12px;">
                <el-button type="primary" size="mini" :disabled="item.order.status != 1"
                  @click="goStar(item.order.id)">評價</el-button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="projects.length <= 0">
          <el-empty description="暫無購買記錄"></el-empty>
        </div>
      </div>
    </div>

    <!-- 退出登錄 -->
    <div style="margin: 30px 0 20px;">
      <div>
        <el-row :gutter="12">
          <el-col :span="8">
            <button style="padding: 14px; background: #FEF8EB; border: 1px solid #ED8E34;
            border-radius: 8px; color: #ED8E34; cursor: pointer; font-size: 15px; width: 100%;" @click="update()">
              修改資料
            </button>
          </el-col>
          <el-col :span="8">
            <button style="padding: 14px; background: #F6F8FB; border: 1px solid #43974E;
            border-radius: 8px; color: #43974E; cursor: pointer; font-size: 15px; width: 100%;" @click="log()">
              餘額記錄
            </button>
          </el-col>
          <el-col :span="8">
            <button style="padding: 14px; background: #F3F0FF; border: 1px solid #6A5BFF;
            border-radius: 8px; color: #6A5BFF; cursor: pointer; font-size: 15px; width: 100%;" @click="goProxy()">
              我的代理
            </button>
          </el-col>
        </el-row>
      </div>
      <div style="margin-top: 12px;">
        <button @click="handleLogout" style="width: 100%; 
               padding: 14px; 
               background: #FFF0F0; 
               border: 1px solid #FF4444; 
               border-radius: 8px; 
               color: #FF4444; 
               font-size: 15px; 
               cursor: pointer;
               transition: all 0.2s;">
          退出登錄
        </button>
      </div>
    </div>

    <!-- 版權聲明 -->
    <div style="margin-top: 30px; padding: 16px; border-top: 1px solid #eee; 
              background: #fafafa; text-align: center;">
      <div style="color: #999; font-size: 12px; line-height: 1.6;">
        <div>Copyright © 2018-2025 碼雲 版權所有</div>
        <div style="margin-top: 4px;">
          <span>技術驅動商業進化</span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      showCopyTip: false,
      projects: [],
      userDataInfo: {},
      showCopySuccess: false,
      fullscreenLoading: false,
      memberList: [],
      member: {
        nick: "初級",
        accumulate: '10000000', //積累充值
        highest: '100', // 當前會員等級限高
        percentage: '10', // 當前進度 百分比
        under: '中級'  // 下一個等級
      },
      nowVip: {},
      nextVip: {},
      set: {}
    }
  },

  mounted() {
    // 刷新用戶信息
    this.refreshUser()

    // 獲取訂單
    this.GetUserOrder()

    // 獲取基礎設置項目
    this.getBasicSettings()

  },
  methods: {
    goStar(e) {
      this.$router.push({
        name: 'Star',
        query: {
          id: e
        }
      });
    },
    meeting() {
      // 在這裏添加點擊處理邏輯
      const a = document.createElement('a');
      console.log(`https://t.me/${this.set.meeting}`)
      a.href = encodeURI(`https://t.me/${this.set.meeting}`);

      a.target = '_blank';
      a.rel = 'noopener noreferrer'; // 安全優化

      // 兼容現代瀏覽器和IE的點擊觸發
      if (document.createEvent) {
        const event = document.createEvent('MouseEvents');
        event.initEvent('click', true, true);
        a.dispatchEvent(event);
      } else {
        a.click();
      }
    },
    GetUserOrder() {
      this.$axios.get("/api/order/list").then(r => {
        this.projects = r.data.data.items
        // console.log(r.data.data)
      })
    },
    getVipData() {
      this.$axios.get("/api/vip_member/arr").then(r => {
        var d = r.data.data
        var res = d.res
        var name = d.name
        var amount = this.userDataInfo.accumulate

        // 檢測現在的會員
        for (var i = 0; i < res.length; i++) {

          if (amount >= res[i]) {
            this.nowVip = {
              name: name[i],
              amount: res[i]
            }
            if (i < res.length) {
              this.nextVip = {
                name: name[i + 1],
                amount: res[i + 1]
              }
            }
          } else {
            break
          }
        }
      })
    },
    goTopUp() {
      this.$router.push({
        name: 'TopUp',
        query: {}
      });
    },
    goProxy() {
      if (this.userDataInfo.is_proxy !== 1) {
        this.$message({
          message: `您沒有權限使用代理功能，如果需要請聯絡客服開通。`,
          type: 'error'
        });
        return
      }
      this.$router.push({
        name: 'Proxy',
        query: {}
      });
    },
    update() {
      this.$router.push({
        name: 'Edit',
        query: {}
      });
    },
    refreshUser() {
      this.$axios.get("/api/user/info").then(res => {
        this.userDataInfo = res.data.data
        localStorage.setItem("userInfo", JSON.stringify(res.data.data))

        // 獲取會員
        this.getVipData()
      })
    },
    // refreshBalance() {
    //   console.log("刷新")
    // },
    formatTimestamp(timestamp, format = 'YYYY-MM-DD HH:mm:ss', isSeconds = true) {
      // 處理秒級時間戳
      const ts = isSeconds ? timestamp * 1000 : timestamp;
      const date = new Date(ts);

      // 時間元素提取
      const year = date.getFullYear();
      const month = date.getMonth() + 1; // 月份從0開始計算
      const day = date.getDate();
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();
      // 補零函數
      const pad = n => n.toString().padStart(2, '0');

      // 格式替換
      return format
        .replace(/YYYY/g, year)
        .replace(/MM/g, pad(month))
        .replace(/DD/g, pad(day))
        .replace(/HH/g, pad(hours))
        .replace(/mm/g, pad(minutes))
        .replace(/ss/g, pad(seconds));
    },
    getBasicSettings() {
      this.$axios.get("/api/set/get").then(res => {
        let d = res.data.data
        this.set = d
      })
    },
    log() {
      this.$router.push({ // 改用 push 導航
        name: 'MoneyLog',
        query: {}
      })
    },
    copyAddress() {
      const textToCopy = this.userDataInfo.trc_address;

      // 方案一：優先使用Clipboard API，失敗後降級使用execCommand
      const textArea = document.createElement('textarea');
      textArea.value = textToCopy;
      textArea.style.position = 'fixed';  // 避免滾動條跳動
      document.body.appendChild(textArea);
      textArea.select();

      try {
        document.execCommand('copy');
        this.showCopySuccess = true;
        setTimeout(() => {
          this.showCopySuccess = false;
        }, 2000);
      } catch (err) {
        console.error('降級複製失敗:', err);
      } finally {
        document.body.removeChild(textArea);
      }

    },
    handleLogout() {
      this.$confirm('是否要退出登錄?', '提示', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteCookie('CAS-ID')
        localStorage.setItem("selTopMenuIndex", 'shop')
        location.reload()
      }).catch(() => {

      });
    },
    formatBalance(value) {
      return (value / 1e6).toLocaleString('en-US', {
        minimumFractionDigits: 6,
        maximumFractionDigits: 6
      });
    },
    deleteCookie(name, path = '/', domain = '') {
      // 設置 Cookie 過期時間為過去（這裏設為 1970-01-01）
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path};${domain ? ` domain=${domain};` : ''}`;
    }
  }
}

</script>

<style>
/* 過渡動畫 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s, transform 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translate(-50%, -20px);
}
</style>